import React, { useState } from "react";
import PropTypes from "prop-types";

const TextInput = ({
  name,
  title,
  type,
  value,
  error,
  handleChange,
  placeholder,
  className,
  page,
}) => {
  return (
    <div className={`${page ? "" : "mb-2"}   text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}
      <input
        type={type}
        className={className ? className : "form-control  form-control-solid"}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          console.log(29, e.target.name, e.target.value)
          handleChange(e);
        }}
      />
      {name !== "agentCode" && (
        <div style={page ? { height: "20px" } : {}} className="mb-2">
          <span className="fs-10 text-danger">{error}</span>
        </div>
      )}
    </div>
  );
};

TextInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  page: PropTypes.string,
};
export default TextInput;
